export type BooleanInput = boolean | 'true' | 'false'

/**
 * Check if boolean input has true value and not is `undefined`
 * @param booleanInput the boolean input
 */
export function isTrueBooleanInput(booleanInput?: BooleanInput): boolean {
  return booleanInput !== undefined && (booleanInput === true || booleanInput === 'true');
}

/**
 * Check if boolean input has false value or is `undefined`
 * @param booleanInput the boolean input
 */
export function isFalseBooleanInput(booleanInput?: BooleanInput): boolean {
  return booleanInput === undefined || booleanInput === false || booleanInput === 'false'
}

export function checkModifica(){

    if (sessionStorage.getItem("__tchd")){
        return confirm("Ci sono modifiche non salvate, vuoi continuare?");
    }
}

export function authLink(url: string){
    if (url && url.startsWith('https://www.comune.laspezia.it')){
        return 'https://www.comune.laspezia.it/td/sso?next=' + encodeURIComponent(url)
    }
    else{
        return url
    }
}


export function getComuneDict(obj:any, ss:string){
    if (obj[`comune${ss}`]){
        const nome = obj[`comune${ss}_nome`];
        const prov = obj[`comune${ss}_prov`];
        const sigla = obj[`comune${ss}_sigla`];

        let lbl: string;
        if (nome && prov && sigla){
            lbl=nome.toLowerCase()==prov.toLowerCase()? nome: `${nome} (${sigla})`;
        }
        else {
            lbl = nome
        }
        return {
            key: obj[`comune${ss}`],
            value: nome,
            label: lbl,
            prov: prov,
            sigla: sigla
        }
    }
}
